
<template>
    <div id="table-box">
        <van-row justify="center">
            <van-col span="6">
                <van-image
                        width="5rem"
                        height="5rem"
                        src="https://afa.activa-leisure.com/img/activa.jpg"
                />
            </van-col>
        </van-row>
        <van-row justify="center">
            <van-col span="20">
                <div class="van-multi-ellipsis--l4">
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;青岛万汇民主评议平台配置列表</p>
                </div>
            </van-col>
        </van-row>

        <van-form @submit="onSubmit">
            <van-cell-group inset>
                <van-field
                        v-model="question0"
                        label="标题"
                        placeholder="请填写标题"
                        required
                        :rules="[{ required: true, message: '请填写标题' }]"
                /><van-field
                        v-model="question1"
                        label="&nbsp;&nbsp;问题1"
                        placeholder="请填写第一个问题"
                />
                <van-field
                        v-model="question2"
                        label="&nbsp;&nbsp;问题2"
                        placeholder="请填写第二个问题"
                />
                <van-field
                        v-model="question3"
                        label="&nbsp;&nbsp;问题3"
                        placeholder="请填写第三个问题"
                />
                <van-field
                        v-model="question4"
                        label="&nbsp;&nbsp;问题4"
                        placeholder="请填写第四个问题"
                />
            </van-cell-group>
            <div style="margin: 16px;">
                <van-button round block type="primary" native-type="submit">
                    提交
                </van-button>
            </div>
        </van-form>
        <van-row justify="center">
            <van-col span="60">
                   <label style="position: relative;top: 6px;"> 清除所有提交信息：</label>
                    <van-button type="danger" @click="clearReview">清除</van-button>
            </van-col>
        </van-row>
    </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import axios from "axios";
import {showConfirmDialog, showDialog} from "vant";

const question0 = ref('');
const question1 = ref('');
const question2 = ref('');
const question3 = ref('');
const question4 = ref('');
let questions = [];

onMounted(() => {
    window.document.title = '青岛万汇民主评议平台配置列表'
    axios.get(process.env.VUE_APP_API_BASE_URL+"/lj/mzpx/questionlist/qd",
        {},
        {
            headers:{
                "content-type": "application/x-www-form-urlencoded"
            }
        }
    ).then( result =>{
        //closeToast();
        if (result.data.success){
            questions = result.data.date;
            //console.log("questions.value："+questions.value);
            // 使用for循环遍历数组
            for (let i = 0; i < questions.length; i++) {
                let question = questions[i];
                if (question.sort === 0){
                    question0.value = question.question;
                }if (question.sort === 1){
                    question1.value = question.question;
                }
                if (question.sort === 2){
                    question2.value = question.question;
                }
                if (question.sort === 3){
                    question3.value = question.question;
                }
                if (question.sort === 4){
                    question4.value = question.question;
                }
            }
        }else {
            console.log(result.data.message)
            showDialog({
                title: '错误提示',
                message: result.data.message,
                theme: 'round-button',
                showConfirmButton:false,
            }).then(() => {
                // on close
            });
        }
        console.log(result);
    })
})

const onSubmit = () => {
    const formData = {
        question0: question0.value,
        question1: question1.value,
        question2: question2.value,
        question3: question3.value,
        question4: question4.value,
        company: 'qd',
    }

    axios.post(process.env.VUE_APP_API_BASE_URL + '/lj/mzpx/questionlist/submit', formData,{
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => {
            console.log('提交成功:', response.data.message)
            // 在这里可以根据后台返回的数据进行相应的处理
            alert(response.data.message)
        })
        .catch(error => {
            if (error.response) {
                // 请求已经发出，但服务器返回状态码不在2xx范围内
                console.error('返回失败:', error.response.const)
            } else {
                // 请求未能发出
                alert('提交失败:' + error.message)
                console.error('提交失败:', error.message)
            }
        })
};

const clearReview = () => {
    showConfirmDialog({
        title: '清除所有提交信息',
        message:
            '您确认清除名主评议所有提交信息吗！请确认清除前进行报表导出数据！',
    })
        .then(() => {
            // on confirm
            axios.get(process.env.VUE_APP_API_BASE_URL+"/lj/mzpx/clear");
            alert("清除成功！")
        })
        .catch(() => {
            // on cancel
        });
}

</script>

<style scoped>

</style>
